module.exports = __webpack_public_path__ + "img/rotate-clockwise.be607395.svg";